import React from 'react'

const AccessDenied = () => {
  return (
    <div style={{textAlign:'center', color:'red', fontSize:'24px', marginTop:'150px'}}>You have insufficient permission to access this page.</div>
  )
}

export default AccessDenied;